module.exports = __webpack_public_path__ + "static/media/logo.4691f121.jpeg";